/**
 * PunchButton — THE button. Large, prominent, mobile-friendly.
 * SDD 7.3 -- 180x180px, radial gradient, toggles Go On Duty (green) / Go Off Duty (red).
 * FR-PUNCH-01: Single prominent on/off duty button.
 */

interface PunchButtonProps {
  isClockedIn: boolean;
  disabled?: boolean;
  onPress: () => void;
  label?: string;
}

export default function PunchButton({ isClockedIn, disabled, onPress, label: customLabel }: PunchButtonProps) {
  const label = customLabel ?? (isClockedIn ? 'GO OFF DUTY' : 'GO ON DUTY');

  return (
    <button
      type="button"
      onClick={onPress}
      disabled={disabled}
      aria-label={label}
      className={`
        w-[180px] h-[180px] rounded-full border-none
        text-white text-[22px] font-bold tracking-wider
        flex items-center justify-center
        touch-manipulation select-none
        transition-all duration-150
        ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer active:scale-95 hover:scale-[1.04]'}
        ${isClockedIn ? 'punch-btn-out' : 'punch-btn-in'}
      `}
      style={{
        background: isClockedIn
          ? 'radial-gradient(circle at 40% 35%, oklch(0.520 0.200 25 / 0.87), oklch(0.520 0.200 25))'
          : 'radial-gradient(circle at 40% 35%, oklch(0.580 0.150 165 / 0.87), oklch(0.550 0.140 165))',
        boxShadow: isClockedIn
          ? '0 0 40px oklch(0.520 0.200 25 / 0.35), 0 4px 20px oklch(0 0 0 / 0.3)'
          : '0 0 40px oklch(0.550 0.140 165 / 0.35), 0 4px 20px oklch(0 0 0 / 0.3)',
      }}
    >
      {label}
    </button>
  );
}
